import { withInstall, withNoopInstall } from '@jdesign-vue/utils'

import Skeleton from './src/skeleton.vue'
import SkeletonItem from './src/skeleton-item.vue'

export const JdSkeleton = withInstall(Skeleton, {
  SkeletonItem,
})
export const JdSkeletonItem = withNoopInstall(SkeletonItem)
export default JdSkeleton

export * from './src/skeleton'
export * from './src/skeleton-item'
